import { Check } from '../../components/ui/icons';

/** One-line explainer — same idea everywhere mini leagues appear. */
export function MiniLeagueExplainer({
  leagueName,
  variant = 'card'
}: {
  leagueName?: string;
  variant?: 'card' | 'inline';
}) {
  const league = leagueName ?? 'your league';
  const body = `Everyone’s ${league} picks count here automatically — same game, private table, no extra work.`;

  if (variant === 'inline') {
    return <p className="text-[12px] font-medium leading-[1.45] text-ink2">{body}</p>;
  }

  return (
    <div className="flex items-start gap-[11px] rounded-[16px] border border-accent/30 bg-accent-wash p-[14px]">
      <div className="grid h-8 w-8 shrink-0 place-items-center rounded-[10px] bg-accent">
        <Check width={17} height={17} strokeWidth={2.6} className="text-white" />
      </div>
      <div>
        <div className="text-[13px] font-extrabold tracking-snug text-accent-ink">How scoring works</div>
        <div className="mt-0.5 text-[12px] font-medium leading-[1.4] text-[#3E7A5E]">{body}</div>
      </div>
    </div>
  );
}
